import { Injectable } from '@angular/core';

@Injectable()
export class ServiceUrlsService {



  // public baseUrl = 'http://localhost:3000/api/';
  
  // public wesiteBaseUrl = "http://localhost:3000/";
  
  // public msRedirectUrl = "http://localhost:3000/ms-signup-response";
  
  // public portalUrl = "http://localhost:8080/ixdcloud";



  // public baseUrl = 'http://demo.insycnhro.net/api/';
  //
  // public wesiteBaseUrl = "http://demo.insycnhro.net/xeye-website/";
  //
  // public msRedirectUrl = "http://demo.insycnhro.net/xeye-website/ms-signup-response";
  //
  // public portalUrl = "http://demo.insycnhro.net/xeye";



   public portalUrl = 'https://portal.executive-eye.com';

   public baseUrl = 'https://executive-eye.com/api/';

   public wesiteBaseUrl = 'https://executive-eye.com/';

   public msRedirectUrl = 'https://executive-eye.com/ms-signup-response';

  constructor() { }

  public signupServiceUrl = this.baseUrl + 'client/signup';

  public resendVerificationServiceUrl = this.baseUrl + 'client/resendVerificationEmail';

  public verifyEmailServiceUrl = this.baseUrl + 'client/verifyEmail';

  public subscribeTrialPlan = this.baseUrl + 'client/subscribeTrialPlan';

  public subscribePremiumPlan = this.baseUrl + 'client/subscribePremiumPlan';

  public sendSupportEmailUrl = this.baseUrl + 'client/sendSupportEmail';

  public registerClientServiceURL = this.baseUrl + 'client/registerClient';

  public msAccessTokenUrl = this.baseUrl + 'microsoft/ms-access-token';

  public msInvitationURL = 'https://graph.microsoft.com/beta/invitations';

  public applyVoucherCodeURL = 'http://104.215.72.80:8080/partner/applyVoucher';


}



// WEBPACK FOOTER //
// ./src/app/common-service/service-urls/service-urls.service.ts